// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3zC4B","two-story-view":"_2jEGk"};